resourcesHandler = {
    $subKitsItem = $('.sub-kits-item'),

    init = function() {
        var self = this;

        if (this.$subKitsItem.length > 0) {
            this.$subKitsItem.on('click', function() {
                var url = $(this).attr("href");
                if (url.includes('#')) {
                    e.preventDefault();
                    if ($(url).length !== 0) {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(url).offset().top
                        }, 'slow');
                    }
                }
            });    
        }

    }
}